<template>
  <div class="Puncture_force_chart" ref="section">
    <div
      class="Puncture_force-animation"
      :class="{ 'animation-triggered': imgVisible }"
    >
      <div class="frame-container">
        <!-- 只顯示當前的 frame PNG -->
        <img
          v-if="imgVisible && frames.length"
          :src="frames[currentFrame]"
          alt="Force Frame"
          class="frame-img"
        />
      </div>
      <!-- 控制 frame 的滑條 -->
      <input
        v-if="imgVisible && frames.length"
        type="range"
        min="0"
        :max="frames.length - 1"
        v-model.number="currentFrame"
        class="frame-slider"
      />
    </div>
    <h1 class="Puncture_force-title">
      <span class="gradient animate-line delay-1">
        <div v-html="$t('TskSelectNeedle.Puncture_force_chart_1')"></div>
      </span>
      <span class="line-1 animate-line delay-2">
        <div v-html="$t('TskSelectNeedle.Puncture_force_chart_2')"></div>
      </span>
    </h1>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgVisible: false,
      hasPlayed: false,
      isMobile: false,
      frames: [],
      currentFrame: 0,
    }
  },
  computed: {
    assetBase() {
      return ''
    },
    frameFolder() {
      return this.isMobile
        ? `${this.assetBase}/mp4/TSN/Puncture_force/phone`
        : `${this.assetBase}/mp4/TSN/Puncture_force/web`
    }
  },
  mounted() {
    this.checkDevice();
    window.addEventListener("resize", this.checkDevice);
    window.addEventListener("orientationchange", this.checkDevice);

    this.generateFrames();

    this.$nextTick(() => {
      this.currentFrame = 0;
      this.imgVisible = true;
    });

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.66 && !this.hasPlayed) {
          this.hasPlayed = true;
          const target = Math.floor(this.frames.length - 1);
          setTimeout(() => {
            this.animateSliderToTarget(target);
          }, 200);
          observer.disconnect();
        }
      },
      { threshold: [0, 0.33, 0.66, 1] }
    );
    observer.observe(this.$refs.section);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkDevice);
    window.removeEventListener("orientationchange", this.checkDevice);
  },
  methods: {
    checkDevice() {
      const isPortrait = window.innerHeight > window.innerWidth;
      const ua = navigator.userAgent;
      const isiPad = /iPad/.test(ua) || (ua.includes("Macintosh") && 'ontouchend' in document);
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

      const wasMobile = this.isMobile;
      this.isMobile = isPortrait && (window.innerWidth <= 820 || isiPad || isTouchDevice);

      if (this.isMobile !== wasMobile) this.generateFrames();
    },
    generateFrames() {
      this.frames = Array.from({ length: 118 }, (_, i) =>
        `${this.frameFolder}/frame_${(i + 1).toString().padStart(3, "0")}.jpg`
      );

      if (this.currentFrame >= this.frames.length) this.currentFrame = 0;

      // 預載入圖片
      this.frames.forEach((src) => {
        const img = new Image();
        img.src = src;
      });
    },
    animateSliderToTarget(target) {
      const duration = 3500;
      const start = this.currentFrame;
      const end = target;
      const startTime = performance.now();

      const animate = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        this.currentFrame = Math.round(start + (end - start) * eased);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          this.currentFrame = end;
        }
      };
      requestAnimationFrame(animate);
    }
  },
  watch: {
    frameFolder() {
      this.generateFrames();
    }
  }
}
</script>


<style scoped>
@keyframes fadeUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.Puncture_force_chart {
/* removed min-height */
/* removed flex */
/* removed justify-content */
/* removed align-items */
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.Puncture_force-animation {
  opacity: 0;
  transition: opacity 0.8s ease;
}
.Puncture_force-animation.animation-triggered {
  opacity: 1;
}
.frame-container {
  width: 100%;
  height: 100vh;           /* 滿版高 */
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;      /* 讓滑條絕對定位依附在這個容器 */
  overflow: hidden;
}
.frame-img {
  width: 100vw;            /* 滿版寬 */
  height: 100vh;           /* 滿版高 */
  object-fit: contain;       /* 滿版不變形，可改 contain 看需求 */
  z-index: 2;
  pointer-events: none;
  user-select: none;
  display: block;
}
.frame-slider {
  position: absolute;
  left: 50%;
  bottom: 10vh;            /* 距底部 40px，可調 */
  transform: translateX(-50%);
  width: 600px;
  z-index: 10;
  /* 刪除 margin、保留自訂 thumb 樣式 */
}

/* Webkit (Chrome, Safari, Edge) */
.frame-slider::-webkit-slider-thumb {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #279EFF 40%, #1ACAD2 100%);
  border: 3px solid #fff;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0,80,150,0.16);
  cursor: pointer;
  transition: background 0.3s;
  appearance: none;
  margin-top: -14px; /* 修正對齊，可依情況微調 */
}

/* Firefox */
.frame-slider::-moz-range-thumb {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #279EFF 40%, #1ACAD2 100%);
  border: 3px solid #fff;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0,80,150,0.16);
  cursor: pointer;
  transition: background 0.3s;
}

/* IE/Edge */
.frame-slider::-ms-thumb {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #279EFF 40%, #1ACAD2 100%);
  border: 3px solid #fff;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0,80,150,0.16);
  cursor: pointer;
  transition: background 0.3s;
}

/* 移除預設樣式，讓 thumb 正確顯示 */
.frame-slider {
  -webkit-appearance: none;
  background: #e4eef5;
  height: 8px;
  border-radius: 8px;
  outline: none;
}
.frame-slider::-webkit-slider-runnable-track {
  height: 8px;
  border-radius: 8px;
  background: #e4eef5;
}
.frame-slider::-moz-range-track {
  height: 8px;
  border-radius: 8px;
  background: #e4eef5;
}
.frame-slider::-ms-fill-lower,
.frame-slider::-ms-fill-upper {
  height: 8px;
  border-radius: 8px;
  background: #e4eef5;
}

/* 修正 Firefox、IE 預設樣式 */
.frame-slider::-ms-tooltip {
  display: none;
}

.Puncture_force-title {
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  font-family: 'PingFang TC', 'Open Sans', 'Noto Sans TC', 'Heiti TC', sans-serif;
  font-size: clamp(1rem, 2vw, 2rem);
  text-align: center;
  line-height: 1.5;
  z-index: 10;
  max-width: 90vw;
  letter-spacing: 0.05em;
  padding: 0 0.1rem;
}
.line-1 {
  display: block;
  color: #111;
  font-weight: 350;
}
.gradient {
  background: linear-gradient(to bottom, #279EFF, #1ACAD2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  font-weight: 900;
  letter-spacing: 0.16em;
}
.animate-line {
  opacity: 0;
  animation: fadeUp 0.8s ease-out forwards;
}
.delay-1 {
  animation-delay: 0.2s;
}
.delay-2 {
  animation-delay: 0.6s;
}
@media (max-width: 900px) {
  .frame-slider {
    width: 70vw !important;
    min-width: 200px;
    max-width: 99vw;
  }
}
</style>
